export default {
  namespaced: true,
  state: {
    dialogVisible: false,
    role: sessionStorage.getItem("role") || "",
    uname: sessionStorage.getItem("uname") || "",
    userNum: sessionStorage.getItem("userNum") || "",
    token: sessionStorage.getItem("token") || "",
  },
  mutations: {
    SET_DIALOG(state, payload) {
      state.dialogVisible = payload;
    },
    
    // 设置
    SET_USERINOF(state, payload) {
      state.role = payload.role;
      state.uname = payload.uname;
      state.userNum = payload.userNum;
      state.token = payload.token;

      sessionStorage.setItem("role", payload.role);
      sessionStorage.setItem("uname", payload.uname);
      sessionStorage.setItem("userNum", payload.userNum);
      sessionStorage.setItem("token", payload.token);
    },
    // 删除
    DELETE_USERINFO(state) {
      state.role = "";
      state.uname = "";
      state.userNum = "";
      state.token = "";

      sessionStorage.removeItem("role");
      sessionStorage.removeItem("uname");
      sessionStorage.removeItem("userNum");
      sessionStorage.removeItem("token");
    },
  },
  actions: {
    async FETCH_LOGIN(context, payload) {
      // const res = await postLoginApi(payload);
      // if (res.meta.state === 200) {
      //   context.commit("SET_USERINOF", res.data);
      // }
      // return res;
      context.commit("SET_USERINOF", payload);
    },
  },
};
